/* GENERATED FILE */
import { type IconProps } from 'phosphor-react-native'

import IconBase from "../lib/icon-base";
import weights from '../defs/Check'

function Check({...props }: IconProps) {
  return (<IconBase {...props} weights={weights} name="check" />)
}

export default Check